import { simpleAction } from 'src/ducks/utils';

import { Anything } from '../../../utils/globalTypes';
import { ActionCreateError, CREATE_ERROR } from './types';

export const createError = (object: Anything): ActionCreateError =>
  simpleAction(CREATE_ERROR, object);
